import { Enable } from 're-resizable';

// Match with media styles
function getMinMaxMinimapHeight(isNarrow: boolean) {
  const { innerWidth: width, innerHeight: height } = window;
  let min = 150;
  let max = 150;

  if (width <= 768) {
    max = isNarrow ? 370 : 300;
  } else if (width > 768 && height <= 550) {
    max = 300;
  } else {
    max = isNarrow ? 535 : 400;
  }

  if (isNarrow) {
    if (width <= 768) {
      min = 180;
    } else if (width > 768 && height <= 550) {
      min = 180;
    } else {
      min = 350;
    }
  }
  return { min, max };
}

const directionToResize: Enable = {
  top: false,
  right: false,
  bottom: false,
  left: false,
  topRight: false,
  bottomRight: false,
  bottomLeft: false,
  topLeft: true,
};

export const getResizeOptions = (isNarrow: boolean) => {
  const { min, max } = getMinMaxMinimapHeight(isNarrow);
  return {
    enable: directionToResize,
    defaultSize: {
      width: 'auto',
      height: min,
    },
    minHeight: min,
    maxHeight: max,
    lockAspectRatio: true,
  };
};
